
import OrderedListItem from "./OrderedListItem.vue"
import RichTextResolver from "storyblok-js-client/dist/rich-text-resolver.cjs"

export default {
  name: "OrderedListItem",
  components: {
    OrderedListItem
  },
  props: {
    block: {
      required: true,
      type: Object
    },
    listIndex: {
      required: true,
      type: String
    },
    secondaryLevel: {
      type: Boolean,
      default: false
    },
    listItemImage: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSecondaryLevel() {
      return (
        this.subItems &&
        ((this.listIndex || "").match(/\./g) || []).length === 2
      )
    },
    isHeading() {
      return this.generatedHtml.indexOf("<h") === 0
    },
    listItemClass() {
      let levelModifier = this.isSecondaryLevel
        ? " ordered-list-item--additional-space"
        : ""
      let firstItemSpace = this.block.spaciousFirstLevelList
        ? " ordered-list-item--additional-primary-space"
        : ""
      let headerModifier = this.isHeading ? " ordered-list-item--header" : ""
      return (
        "ordered-list-item" + headerModifier + levelModifier + firstItemSpace
      )
    },
    numberClass() {
      const headerClass = this.isHeading ? this.generatedHtml.substr(1, 2) : ""
      const colourClass =
        this.block.numberingColour && this.block.numberingColour.length
          ? " ordered-list-item__number--" + this.block.numberingColour
          : ""
      const textSizeClass =
        this.block.numberingSize && this.block.numberingSize.length
          ? " ordered-list-item__number--" + this.block.numberingSize
          : ""

      return (
        "ordered-list-item__number " + headerClass + colourClass + textSizeClass
      )
    },
    generatedHtml() {
      let text = ""

      if (typeof this.block.title === "string") {
        text = this.block.title
      } else {
        const resolver = new RichTextResolver()
        text = resolver.render(this.block.title)
      }
      return text
    }
  }
}
